import styled from 'styled-components';

import bg from '~/assets/tv/implants/balls-bg.png';

interface ISlide {
  show: boolean;
  startAnim: boolean;
  notShow?: boolean;
}

export const Container = styled.div<ISlide>`
  position: absolute;
  top: 0;
  left: 0;
  transition-duration: 0.3s;
  opacity: ${(props) => (props.show ? 1 : 0)};
  background: #f0f0f0;
  min-width: 980px;
  min-height: 551.25px;
`;

export const Slide = styled.div<ISlide>`
  position: absolute;
  top: 0;
  left: 0;
  transition-duration: 0.3s;
  opacity: ${(props) => (props.show ? 1 : 0)};
  background-image: url(${bg});

  .slide-container {
    width: 980px;
    height: 551.25px;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    z-index: 1;

    .title {
      position: absolute;
      left: 56.56px;
      top: 216.5px;
      width: 209.29px;
      color: #b2722b;
      font-size: 24px;
      font-weight: 500;
      line-height: 33.81px;
    }

    .name {
      position: absolute;
      left: 56.56px;
      top: 308.14px;
      width: 300px;
      color: #202020;
      font-size: 45px;
      font-weight: 500;
      line-height: 63.4px;
    }

    .content {
      position: absolute;
      left: 56.56px;
      top: 371.14px;
      width: 370px;
      color: #202020;
      font-size: 24px;
      font-weight: 300;
      line-height: 33.81px;
    }

    .doctor {
      position: absolute;
      left: 467.91px;
      top: 0;
      width: 512.09px;
      height: 551px;
    }
  }
`;
